import ServiceDetail from "@/components/ServiceDetail";
import { SERVICES_DATA } from "@/data/services";
import { GALLERY_ITEMS } from "@/data/gallery";

export default function Interlocking() {
    const projects = GALLERY_ITEMS.filter((g) => g.category === "interlocking");
    return <ServiceDetail data={SERVICES_DATA.interlocking} projects={projects} />;
}
